export default __webpack_public_path__ + "public/assets/images/ec636c78983c16e8be5d67203fd422d7.png";